enum Status {

  NONE = '',
  DONE = 'done',
  READY = 'ready',
  MISSED = 'missed',
  WAITING = 'waiting',
  APPROVED = 'approved',
  CANCELED = 'canceled',
  AVAILABLE = 'available',
  CONFIRMED = 'confirmed',
  PROCESSING = 'processing',
  NOT_APPROVED = 'notapproved',
  AWAITING_APPROVAL = 'awaitingapproval',

}

export default Status;
